export default {
  recruitPage: { list: {}, navInfo: {} },
  recruitDetail: {},
};
